import { useMemo } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { DrawerHashRoute } from '../../../../containers/Drawers/types';
import Button from '../../../../elements/Button';

const CreateNewProjectButton = () => {
  const createNewProjectButton = useMemo(
    (): JSX.Element => (
      <Link to={DrawerHashRoute.OVRForm}>
        <Button type="primary" data-cy="create-new-ovr-project-btn">
          Create New Project
          <PlusOutlined />
        </Button>
      </Link>
    ),
    []
  );

  return createNewProjectButton;
};

export default CreateNewProjectButton;
